import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Star, X, Heart } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shown once, right after a member completes their first Symptom Awareness Check.
export const RatingModal = ({ onClose, onSubmitted }) => {
  const [stars, setStars] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!stars) { toast.message("Please tap a star to rate ASAL"); return; }
    setSaving(true);
    try {
      await axios.post(`${API}/feedback/rating`, { stars, comment: comment.trim() || null });
      if (onSubmitted) await onSubmitted();
      toast.success("Thank you — your feedback helps ASAL improve");
      onClose();
    } catch {
      setSaving(false);
      toast.error("Could not send your rating. Please try again.");
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4" data-testid="rating-modal">
      <div className="bg-white rounded-2xl w-full max-w-md p-6 relative shadow-xl">
        <button onClick={onClose} data-testid="rating-close" className="absolute top-4 right-4 text-slate-400 hover:text-slate-600"><X size={20} /></button>
        <div className="w-12 h-12 rounded-xl bg-[#e6f4f2] text-[#0d9488] flex items-center justify-center"><Heart size={24} /></div>
        <h2 className="font-head font-bold text-slate-800 text-xl mt-4">How's ASAL working for you?</h2>
        <p className="text-slate-500 text-sm mt-1">Your feedback helps us make ASAL better for everyone. It only takes a moment.</p>

        <div className="flex items-center gap-2 mt-5" data-testid="rating-stars">
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} type="button" data-testid={`rating-star-${n}`}
              onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)} onClick={() => setStars(n)}
              className="transition-transform hover:scale-110">
              <Star size={34} className={(hover || stars) >= n ? "text-amber-400 fill-amber-400" : "text-slate-300"} />
            </button>
          ))}
        </div>

        <textarea value={comment} onChange={(e) => setComment(e.target.value)} data-testid="rating-comment" rows={3}
          placeholder="Anything you'd like to tell us? (optional)"
          className="w-full mt-4 px-3 py-2 rounded-lg border border-slate-200 text-sm outline-none focus:border-[#0d9488] resize-none" />

        <div className="flex gap-3 mt-4">
          <button onClick={submit} disabled={saving} data-testid="rating-submit"
            className="flex-1 h-11 rounded-lg bg-[#0d9488] hover:bg-[#0f766e] disabled:opacity-60 text-white font-semibold text-sm transition-colors">
            {saving ? "Sending…" : "Submit rating"}
          </button>
          <button onClick={onClose} disabled={saving} className="h-11 px-4 rounded-lg border border-slate-200 text-slate-600 font-semibold text-sm hover:bg-slate-50 transition-colors">Maybe later</button>
        </div>
      </div>
    </div>
  );
};

export default RatingModal;
